export default {
    title: String,
    image: String,
    id: Number,
    amount: Number,
    amountWithoutTaxes: Number,
    paymentMethod: Number,
    paymentMethodCode: Number,
    date: Date,
    duration: String,
    installments: Number,
    billetExpireDate: Date,
    billetUrl: String,
    travelers: Array,
    accommodations: Array,
    optionals: Array,
    isCancellable: Boolean,
    canDownloadBillet: Boolean,
    tripUrl: String,
    availableRefundAmount: Number,
    availableRefundPercent: Number,
    statusCode: Number,
    status: Number,
    agencyName: String,
    agencyTerms: {
        type: String,
        default: null
    },
    companyTerms: {
        type: String,
        default: null
    },
    satisfactionSurveyId: {
        type: String,
        default: null
    },
    satisfactionSurveyAnswered: {
        type: Boolean,
        default: false
    },
    isRecebeAquiOrder: {
        type: Boolean,
        default: false
    }
}
